module.exports = "/_next/static/images/DM2-fe826675dfb66afba9371c99d43faec2.jpg";